import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "flex flex-col gap-6" };
const _hoisted_2 = { class: "flex flex-col gap-3" };
const _hoisted_3 = { class: "flex items-center gap-1.5" };
const _hoisted_4 = { class: "text-base font-bold text-(--text-text-heading)" };
const _hoisted_5 = {
    key: 0,
    class: "flex flex-col gap-3.5"
};
const _hoisted_6 = {
    key: 1,
    class: "text-sm text-(--text-text-body-subtle)"
};
const _hoisted_7 = { class: "flex flex-col gap-3" };
const _hoisted_8 = { class: "flex items-center gap-1.5" };
const _hoisted_9 = { class: "text-base font-bold text-(--text-text-heading)" };
const _hoisted_10 = {
    key: 0,
    class: "flex flex-col gap-3.5"
};
const _hoisted_11 = {
    key: 1,
    class: "text-sm text-(--text-text-body-subtle)"
};
import { computed } from "vue";
import { Button, Tooltip } from "@eudonet/opal";
import OrganisationChannelRow from "./OrganisationChannelRow.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrganisationCoordonneesSection',
    props: {
        phones: {},
        emails: {},
        canInteract: { type: Boolean },
        tooltip: {}
    },
    emits: ["editPhone", "editEmail"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const sortedPhones = computed(() => [...props.phones].sort((a, b) => Number(b.isPrimary) - Number(a.isPrimary)));
        const sortedEmails = computed(() => [...props.emails].sort((a, b) => Number(b.isPrimary) - Number(a.isPrimary)));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _cache[0] || (_cache[0] = _createElementVNode("i", {
                            class: "ri-phone-line text-xl text-(--text-text-heading)",
                            "aria-hidden": "true"
                        }, null, -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('organisation.detail.communication.telephonesTitle')), 1 /* TEXT */)
                    ]),
                    (sortedPhones.value.length)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedPhones.value, (phone) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: phone.id
                                }, [
                                    _createVNode(OrganisationChannelRow, {
                                        type: "phone",
                                        value: phone.number,
                                        "is-primary": phone.isPrimary
                                    }, {
                                        actions: _withCtx(() => [
                                            _createVNode(_unref(Tooltip), {
                                                text: __props.tooltip,
                                                disabled: __props.canInteract,
                                                tabindex: !__props.canInteract ? 0 : undefined
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_unref(Button), {
                                                        variant: "secondary",
                                                        size: "xs",
                                                        "icon-only": true,
                                                        "icon-left": "ri-pencil-line",
                                                        disabled: !__props.canInteract,
                                                        "aria-label": _ctx.$t('organisation.detail.communication.editPhoneAriaLabel'),
                                                        onClick: ($event) => (emit('editPhone', phone))
                                                    }, null, 8 /* PROPS */, ["disabled", "aria-label", "onClick"])
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text", "disabled", "tabindex"])
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "is-primary"])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t('organisation.detail.communication.noPhone')), 1 /* TEXT */))
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _cache[1] || (_cache[1] = _createElementVNode("i", {
                            class: "ri-mail-line text-xl text-(--text-text-heading)",
                            "aria-hidden": "true"
                        }, null, -1 /* CACHED */)),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('organisation.detail.communication.emailsTitle')), 1 /* TEXT */)
                    ]),
                    (sortedEmails.value.length)
                        ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedEmails.value, (email) => {
                                return (_openBlock(), _createElementBlock("li", {
                                    key: email.id
                                }, [
                                    _createVNode(OrganisationChannelRow, {
                                        type: "email",
                                        value: email.address,
                                        "is-primary": email.isPrimary
                                    }, {
                                        actions: _withCtx(() => [
                                            _createVNode(_unref(Tooltip), {
                                                text: __props.tooltip,
                                                disabled: __props.canInteract,
                                                tabindex: !__props.canInteract ? 0 : undefined
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_unref(Button), {
                                                        variant: "secondary",
                                                        size: "xs",
                                                        "icon-only": true,
                                                        "icon-left": "ri-pencil-line",
                                                        disabled: !__props.canInteract,
                                                        "aria-label": _ctx.$t('organisation.detail.communication.editEmailAriaLabel'),
                                                        onClick: ($event) => (emit('editEmail', email))
                                                    }, null, 8 /* PROPS */, ["disabled", "aria-label", "onClick"])
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["text", "disabled", "tabindex"])
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["value", "is-primary"])
                                ]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]))
                        : (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.$t('organisation.detail.communication.noEmail')), 1 /* TEXT */))
                ])
            ]));
        };
    }
});
